import { buildActiveStatusWhereClauses } from "./objectStatus.helpers";

export const SIDE_MENU_OBJECTS_PAGE_SIZE = 25;

export const buildSideMenuObjectsQueryParams = (
  search: string,
  page: number = 1,
  showInactiveObjects: boolean = false
) => ({
  itemsPerPage: SIDE_MENU_OBJECTS_PAGE_SIZE,
  page,
  where: [
    { field: "name", value: search, type: 0 },
    ...buildActiveStatusWhereClauses(showInactiveObjects)
  ],
  orderBy: [{ field: "name", ascending: true }]
});
